﻿<script lang="ts">
	export let tooltip: string | null = null;
	export let name: string;
	export let size = "";

	$: classNames = `icon ${size} ${$$restProps["class"] ?? ""}`.trim();
	$: svgHref = `#icon:${name}`;
</script>

<svg {...$$restProps} class={classNames} data-tooltip={tooltip}>
	{#if tooltip != null && tooltip.length > 0}
		<title>{tooltip}</title>
	{/if}
	<use xlink:href={svgHref} />
</svg>
